<template lang="pug">
.image-box(:style="{ height: height }")
  .bg-img(:style="{ backgroundImage: 'url(' + url + ')'}")
</template>

<script>
export default {
  name: 'image_box',
  data() {
    return {
      height: '0px',
      isListenning: true,
    };
  },
  props: {
    url: {
      type: String,
      default: '',
      required: true,
    },
    ratio: {
      type: Number,
      default: (9 / 16),
    },
    widthRatio: {
      type: Number,
      default: 1,
    },
    syncHeight: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    syncHeight() {
      this.height = `${this.syncHeight}px`;
      if (this.isListenning) {
        window.removeEventListener('resize', this.handleResize);
        this.isListenning = false;
      }
    },
  },
  mounted() {
    if (this.widthRatio === 1) {
      this.handleResize();
    } else {
      this.handleInitial();
    }
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      const width = this.$el.clientWidth;
      const height = Number(width) * this.ratio;
      this.$el.style.width = '100%';
      this.height = `${height}px`;
      this.$emit('onResize', width, height);
    },
    handleInitial() {
      const width = this.$el.clientWidth * this.widthRatio;
      const height = Number(width) * this.ratio;
      this.$el.style.width = `${width}px`;
      this.height = `${height}px`;
    },
  },
};
</script>

<style lang="stylus" scoped>
.image-box
  width 100%
  height 100%
  .bg-img
    height 100%
    overflow hidden
    background-size cover
    background-position center
    cursor pointer
</style>



// WEBPACK FOOTER //
// ImageBox.vue?50db62ff